var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-comp d-flex justify-center animation-opacity"},[_c('h1',{staticClass:"text-body-title"},[_vm._v(" "+_vm._s(_vm.smsNotData)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }